<template>
  <ClientOnly>
    <template #fallback>
      <template v-for="rentUnit in rentUnits" :key="rentUnit.id">
        <USkeleton
          class="h-72 mb-2 md:h-52 md:mb-5 ring-1 rounded-lg ring-gray-200"
        />
      </template>
    </template>
    <CottagePricesRentUnitCard
      v-for="rentUnit in rentUnits"
      :key="rentUnit.id"
      :rent-unit-id="rentUnit.id"
      :maximum-capacity="rentUnit.capacity"
      :current-state="getCurrentState(rentUnit)"
      :min-nights="
        pricesStore.getRentUnitPricesById(rentUnit.id)?.minNights ?? 0
      "
      :hide-select="hideSelect"
      :show-online-booking="showOnlineBooking"
      @open-modal="$emit('open-modal', $event)"
      @open-date-modal="$emit('open-date-modal', $event)"
      @toggle-select="onToggleSelect($event)"
      @submit-prices-form="$emit('submit-prices-form', $event)"
    />
  </ClientOnly>
</template>
<script setup lang="ts">
import CottagePricesRentUnitCard from './CottagePricesRentUnitCard.vue'
import {
  usePricesStore,
  type ShowRentUnits,
  type CottageDetail,
} from '~~/modules/views/cottage-prices/stores/pricesStore'

const route = useRoute()

// Remove old props, only keep disableRentUnits
const props = defineProps<{
  disableRentUnits: boolean
}>()

defineEmits(['open-modal', 'open-date-modal', 'submit-prices-form'])

const pricesStore = usePricesStore()

const rentUnits: Ref<ShowRentUnits> = computed(() => pricesStore.getRentUnits)
const cottageDetail: Ref<CottageDetail> = computed(
  () => pricesStore.getCottageDetail,
)

const showOnlineBooking = computed(() => {
  return cottageDetail.value?.salesService.isOnlineBookingActive || false
})

const hideSelect = computed(() => {
  const rentUnitsStructure = pricesStore.rentUnitsStructure
  return rentUnitsStructure?.rentUnitStructure === 'SINGLE_UNIT'
})

const getCurrentState = (rentUnit: any) => {
  if (props.disableRentUnits) return 'DISABLED'

  const rentUnitPrices = pricesStore.getRentUnitPricesById(rentUnit.id)

  if (rentUnitPrices?.isMinNightsRequired) {
    return 'READY_MIN_NIGHTS_REQUIRED'
  } else if (rentUnitPrices?.hasNoDatesAvailable) {
    return 'READY_NO_VACANCY'
  } else if (
    !rentUnitPrices?.pricesByPlaces ||
    rentUnitPrices.pricesByPlaces.length === 0
  ) {
    return 'READY_NO_PRICES'
  } else if (
    !route.query.dateIn ||
    !route.query.dateOut ||
    !route.query.capacity
  ) {
    return 'READY'
  } else {
    for (const selection of pricesStore.getSelectedRentUnits) {
      const selectedRentUnitData = pricesStore.getRentUnits.find(
        ru => ru.id === selection.id,
      )
      if (
        selectedRentUnitData?.relatedRentUnitUIds?.includes(rentUnit.id) &&
        rentUnit.id !== selection.id
      ) {
        return 'READY_WITH_PRICES_DISABLED'
      }
    }
    return 'READY_WITH_PRICES'
  }
}

const onToggleSelect = (rentUnit: any) => {
  pricesStore.toggleRentUnit(rentUnit.id, rentUnit.selectedPeople || 1)
}
</script>
